import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { preloadMusic } from '../../state/actions/audio';
import musicList from '../../assets/star/sounds/index';
import { SceneView } from '@react-navigation/core';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import Screens from '../../screens';
import Utils from '../../utils';
import QueryParamsProxy from '../../utils/queryParamProxy';
import audio from '../../utils/audio';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import handleFeatureFlagsStore from '../../utils/featureFlags/HandleFeatureFlagsStore';
import { FEATURE_FLAGS_PROVIDERS } from '../../utils/featureFlags';
import { setOnboardingFtueStep } from '../../state/actions/currentOnboarding';
import { useLazyGetUrlsQuery } from '../../state/query/urls';
import { BOOLEANS, EVENTS, FTUE_STEPS_KEYS, PLATFORM } from '../../constants';
import { AUTH_TYPES } from '../../utils/authFlow/constants';
import { useGetTextsQuery } from '../../state/query/texts';
import useNotification from '../../hooks/useNotification';
import { TEXT_KEY, getText } from '../../utils/localization';

var useAuthSwitchShared = function useAuthSwitchShared(props) {
  useGetTextsQuery({
    lang: ENVIRONMENT_VARIABLES.LANGUAGE
  });
  var navigation = props.navigation,
      descriptors = props.descriptors,
      audioPlayer = props.audioPlayer;
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state.token;
  }),
      token = _useSelector.token;

  var _useSelector2 = useSelector(function (state) {
    return state.app;
  }),
      appBackground = _useSelector2.appBackground,
      restartSession = _useSelector2.restartSession,
      assetsUrls = _useSelector2.assetsUrls; // 5


  var _useSelector3 = useSelector(function (state) {
    return state.playerInfo;
  }),
      playerId = _useSelector3.playerId;

  var _useSelector4 = useSelector(function (state) {
    return state.callbackIntent;
  }),
      auth = _useSelector4.auth;

  var _useSelector5 = useSelector(function (state) {
    return state.device;
  }),
      isConnected = _useSelector5.isConnected;

  var ftueStep = useSelector(function (state) {
    return state.currentOnboarding.ftueStep;
  });
  var background = useSelector(function (state) {
    return state.promotions.background;
  });
  var initAssetsLoaded = useSelector(function (state) {
    return state.load.initAssetsLoaded;
  });
  var lastInitApp = useSelector(function (state) {
    return state.load.lastInitApp;
  });
  var initTextsLoaded = useSelector(function (state) {
    return state.load.initTextsLoaded;
  });

  var _useNotification = useNotification(),
      notification = _useNotification.notification,
      addNotification = _useNotification.addNotification,
      clearNotification = _useNotification.clearNotification;

  var _useLazyGetUrlsQuery = useLazyGetUrlsQuery(),
      _useLazyGetUrlsQuery2 = _slicedToArray(_useLazyGetUrlsQuery, 1),
      trigger = _useLazyGetUrlsQuery2[0];

  var handleInitializeAuthSwith = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            initializeAudio(musicList);
            Logger.sendEvent(EVENT_TYPES.VIEW);

            if (!isConnected) {
              addNotification({
                message: getText(TEXT_KEY.INTERNET_CONNECTION),
                title: getText(TEXT_KEY.CONNECTION_LOST_TITLE),
                hideCloseButton: true,
                hideHelpButton: true
              });
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, {
                description: EVENTS.APP_CURRENTLY_NOT_AVAILABLE,
                code: 4
              });
            } else {
              if (notification) clearNotification();
            }

            trigger();

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [initializeAudio, isConnected, trigger]);
  var chechFTUE = useCallback(function () {
    if (ftueStep) {
      if (Utils.getPlatform() === PLATFORM.WEB) {
        QueryParamsProxy.navigate(navigation, Screens.Home);
      }

      dispatch(setOnboardingFtueStep(FTUE_STEPS_KEYS.INITIAL));
    }
  }, []);
  var initializeAudio = useCallback(function (musicList) {
    var musicPlayers = {};

    if (Utils.getPlatform() === PLATFORM.WEB) {
      musicList = Object.entries(musicList);

      for (var i = 0; i < musicList.length; i++) {
        var url = musicList[i]['1'].url;

        var _audio = new Audio(url);

        _audio.loop = musicList[i]['1'].loop ? musicList[i]['1'].loop : false;
        musicPlayers[musicList[i]['0']] = _audio;
      }
    } else {
      var musicListCopy = {};
      musicListCopy = musicList;
      musicList = Object.entries(musicList);

      for (var _i = 0; _i < musicList.length; _i++) {
        var currentTrackName = musicList[_i]['0'];
        var currentTrack = musicListCopy[currentTrackName];
        var soundPlayer = audioPlayer.playSound(currentTrack);
        musicPlayers[musicList[_i]['0']] = soundPlayer;
      }
    }

    dispatch(preloadMusic(musicPlayers));
  }, [dispatch, audioPlayer]);
  var checkAuthorization = useCallback(function () {
    var routeName = navigation.state.routes[navigation.state.index].routeName;
    console.log("location: ".concat(window.location));
    console.log("current route: ".concat(routeName));

    if (routeName === Screens.TrackingURL) {
      QueryParamsProxy.navigate(navigation, Screens.TrackingURL);
      return;
    }

    for (var _i2 = 0, _arr = [ENVIRONMENT_VARIABLES.SSO_CALLBACK_PATH, Screens.FinishWebPurchase]; _i2 < _arr.length; _i2++) {
      var route = _arr[_i2];
      console.log("route: ".concat(route));
      if (routeName === route) return;
    }

    if (token === '') {
      QueryParamsProxy.navigate(navigation, Screens.Start);
      return;
    }

    if (auth === AUTH_TYPES.LINK) {
      QueryParamsProxy.navigate(navigation, Screens.LinkLoyaltyCard);
      return;
    }

    loginSuccessHandler();
  }, [token, loginSuccessHandler]);
  var loginSuccessHandler = useCallback(function () {
    QueryParamsProxy.navigate(navigation, Screens.Lobby);
    audio.pauseSfx();
  }, [navigation]);
  useEffect(function () {
    chechFTUE();
  }, [chechFTUE]);
  useEffect(function () {
    handleInitializeAuthSwith();
  }, [handleInitializeAuthSwith]);
  useEffect(function () {
    checkAuthorization();
  }, [checkAuthorization]);
  useEffect(function () {
    if (playerId && token) handleFeatureFlagsStore(FEATURE_FLAGS_PROVIDERS.DIVE_PROVIDER, playerId);
  }, [playerId, token]);
  return {
    descriptor: descriptors[navigation.state.routes[navigation.state.index].key],
    SceneView: SceneView,
    appBackground: appBackground,
    backgroundPromo: background,
    initTextsLoaded: initTextsLoaded,
    hasAssetsLoaded: initAssetsLoaded && lastInitApp > 0 && token || !token || ENVIRONMENT_VARIABLES.PRELOAD_ASSETS === BOOLEANS.FALSE,
    promotionImagesUrl: assetsUrls ? assetsUrls.promotionImagesUrl : null,
    restartSession: restartSession,
    isConnected: isConnected
  };
};

export default useAuthSwitchShared;